import React from 'react';
import axios from 'axios';

const API = `${(process.env.REACT_APP_BACKEND_URL || 'https://bobine.live')}/api`;

const CompareOverlay = ({
  compareData, comparePos, setComparePos,
  setCompareData, setViewerIndex, token,
  setPhotos, setHasMore, setPhotosPage, t,
}) => (
  <div
    data-testid="compare-overlay"
    style={{
      position: 'fixed', inset: 0, zIndex: 70,
      backgroundColor: 'rgba(0,0,0,0.95)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      animation: 'fadeIn 0.4s ease-out',
    }}
  >
    <div
      onClick={e => e.stopPropagation()}
      data-testid="compare-slider"
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: '90vw', padding: '20px 0' }}
    >
      <h3 style={{
        fontFamily: "'Georgia', serif", fontSize: 18,
        color: '#D4AF37', marginBottom: 20, letterSpacing: 1.5, fontWeight: 400,
      }}>
        {t('viewer_restore_title')}
      </h3>

      <div style={{
        position: 'relative', overflow: 'hidden',
        borderRadius: 10, cursor: 'col-resize',
        border: '1px solid rgba(212,175,55,0.25)',
        boxShadow: '0 0 60px rgba(212,175,55,0.08)',
        maxWidth: '85vw', maxHeight: '60vh',
      }}
        onMouseDown={() => {}}
        onMouseMove={e => {
          const rect = e.currentTarget.getBoundingClientRect();
          const x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
          setComparePos(x);
        }}
        onTouchMove={e => {
          const rect = e.currentTarget.getBoundingClientRect();
          const touch = e.touches[0];
          const x = Math.max(0, Math.min(100, ((touch.clientX - rect.left) / rect.width) * 100));
          setComparePos(x);
        }}
      >
        <img
          src={`${API}/photos/${compareData.restoredId}/image?token=${token}`}
          alt="Restaure"
          data-testid="compare-after-img"
          style={{ display: 'block', maxWidth: '85vw', maxHeight: '60vh', objectFit: 'contain' }}
        />
        <div style={{
          position: 'absolute', inset: 0,
          clipPath: `inset(0 ${100 - comparePos}% 0 0)`,
        }}>
          <img
            src={compareData.originalSrc}
            alt="Original"
            data-testid="compare-before-img"
            style={{ display: 'block', width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </div>
        <div style={{
          position: 'absolute', top: 0, bottom: 0,
          left: `${comparePos}%`, transform: 'translateX(-50%)',
          width: 2, background: 'linear-gradient(145deg, #D4AF37, #B8860B)',
          boxShadow: '0 0 12px rgba(212,175,55,0.6)',
        }}>
          <div style={{
            position: 'absolute', top: '50%', left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 36, height: 36, borderRadius: '50%',
            backgroundColor: '#000', border: '2px solid #D4AF37',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 2px 16px rgba(0,0,0,0.6)',
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2.5"><polyline points="8 4 4 12 8 20"/><polyline points="16 4 20 12 16 20"/></svg>
          </div>
        </div>
        <span style={{
          position: 'absolute', top: 12, left: 12,
          fontFamily: "'Georgia', serif", fontSize: 11,
          color: '#D4AF37', backgroundColor: 'rgba(0,0,0,0.7)',
          padding: '5px 12px', borderRadius: 4, letterSpacing: 1.5, fontWeight: 600,
        }}>{t('viewer_before')}</span>
        <span style={{
          position: 'absolute', top: 12, right: 12,
          fontFamily: "'Georgia', serif", fontSize: 11,
          color: '#D4AF37', backgroundColor: 'rgba(0,0,0,0.7)',
          padding: '5px 12px', borderRadius: 4, letterSpacing: 1.5, fontWeight: 600,
        }}>{t('viewer_after')}</span>
      </div>

      <div style={{ marginTop: 24, display: 'flex', gap: 16, justifyContent: 'center' }}>
        <button
          data-testid="restore-reject"
          onClick={async () => {
            try {
              await axios.post(`${API}/restore/reject`, { restored_photo_id: compareData.restoredId }, { headers: { Authorization: `Bearer ${token}` } });
            } catch {}
            setCompareData(null); setViewerIndex(null); setComparePos(50);
          }}
          style={{
            fontFamily: "'Georgia', serif", fontSize: 14, fontWeight: 500,
            padding: '12px 28px', borderRadius: 8, cursor: 'pointer',
            background: 'none', border: '1px solid rgba(231,76,60,0.5)',
            color: '#e74c3c', transition: 'all 0.3s',
          }}
          onMouseEnter={e => { e.currentTarget.style.backgroundColor = 'rgba(231,76,60,0.1)'; }}
          onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; }}
        >
          {t('restore_reject')}
        </button>
        <button
          data-testid="restore-accept"
          onClick={async () => {
            try {
              await axios.post(`${API}/restore/confirm`, { restored_photo_id: compareData.restoredId }, { headers: { Authorization: `Bearer ${token}` } });
              const photosRes = await axios.get(`${API}/photos?page=1&limit=24`, { headers: { Authorization: `Bearer ${token}` } });
              setPhotos(photosRes.data.photos || []);
              setHasMore(photosRes.data.has_more || false);
              setPhotosPage(1);
            } catch {}
            setCompareData(null); setViewerIndex(null); setComparePos(50);
          }}
          style={{
            fontFamily: "'Georgia', serif", fontSize: 14, fontWeight: 600,
            padding: '12px 28px', borderRadius: 8, cursor: 'pointer',
            background: 'linear-gradient(145deg, #D4AF37, #B8860B)', color: '#000', border: 'none',
            boxShadow: '0 2px 16px rgba(212,175,55,0.3)',
            transition: 'all 0.3s',
          }}
          onMouseEnter={e => { }}
          onMouseLeave={e => { }}
        >
          {t('restore_accept')}
        </button>
      </div>
    </div>
  </div>
);

export default CompareOverlay;
